import * as St from './PlainCard.styles';

export type PlainCardProps = React.ComponentProps<typeof St.Container> & {
  isSelected?: boolean;
  isDisabled?: boolean;
  withHover?: boolean;
  onClick?: () => void;
};

const PlainCard = ({
  isSelected = false,
  isDisabled = false,
  withHover = false,
  ...props
}: PlainCardProps) => {
  const onClick = isDisabled ? undefined : props.onClick;

  return (
    <St.Container
      {...props}
      onKeyDown={
        onClick &&
        ((event: React.KeyboardEvent) => {
          if (event.code === 'Space') {
            event.preventDefault();
            onClick();
          }
        })
      }
      {...(onClick ? { tabIndex: 0 } : {})}
      aria-selected={isSelected && !isDisabled}
      aria-disabled={isDisabled}
      onClick={onClick}
      data-hover={withHover && !isDisabled}
    />
  );
};

export default PlainCard;
